import React from "react";
import Page, { PageProps } from "../Page";
import { IAttributeCodebookPresenter } from "../../../presenter/valuelist/AttributeCodebookPresenter";
import { Select, Divider, Form, Icon, Button, Modal } from "antd";
import DataGrid from "../../components/app/grid/DataGrid";
import CreateAttributeCodebookForm, {
  CreateAttributeCodebookFormProps
} from "./CreateAttributeCodebookForm";
import UpdateAttributeCodebookForm, {
  UpdateAttributeCodebookFormProps
} from "./UpdateAttributeCodebookForm";
import CreateCodebookForm, {
  CreateCodebookFormProps
} from "./CreateCodebookForm";
import { TGridAction } from "../../components/app/grid/GridActionsDropdown";
import { IValueListItem } from "../../../model/valuelist/ValueListItem";

const { Option } = Select;
const { confirm } = Modal;

export interface Props extends PageProps {}

export interface State extends IAttributeCodebookPresenter {}

export default class AttributeCodebookPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      attributeCodeList,
      selectedAttributeCode,
      referenceList,
      onChangeAttributeCode,
      updateAttributeReference,
      createAttributeReference,
      deleteAttributeReferenceList,
      onChangeAttributeModalVisible,
      attributeModalVisible,
      createAttributeCodebook,
      deleteAttributeReference
    } = this.state;

    const CreateForm = Form.create<CreateAttributeCodebookFormProps>({})(
      CreateAttributeCodebookForm
    );

    const UpdateForm = Form.create<UpdateAttributeCodebookFormProps>({})(
      UpdateAttributeCodebookForm
    );

    const CreateModalForm = Form.create<CreateCodebookFormProps>({
      name: "form_in_modal"
    })(CreateCodebookForm);

    const columns = [
      {
        title: translate("attribute_codebook.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("attribute_codebook.value"),
        dataIndex: "value",
        key: "value"
      }
    ];

    function showWarningModal() {
      confirm({
        title: translate("attribute_codebook.delete_codebook"),
        content: (
          <div>
            <p>
              {translate("attribute_codebook.delete_modal_message", {
                codebook: selectedAttributeCode
              })}
            </p>
          </div>
        ),
        icon: <Icon type="warning" theme="filled" />,
        okText: translate("modal_functions.delete_modal.delete"),
        cancelText: translate("modal_functions.delete_modal.cancel"),
        onOk() {
          deleteAttributeReferenceList();
        }
      });
    }

    function showDeleteValueWarningModal(valueListItem: IValueListItem) {
      confirm({
        title: translate("attribute_codebook.delete_value_item"),
        content: (
          <div>
            <p>
              {translate("attribute_codebook.delete_value_modal_message", {
                value: valueListItem.code
              })}
            </p>
          </div>
        ),
        icon: <Icon type="warning" theme="filled" />,
        okText: translate("modal_functions.delete_modal.delete"),
        cancelText: translate("modal_functions.delete_modal.cancel"),
        onOk() {
          deleteAttributeReference(valueListItem.id);
        }
      });
    }

    const actions: TGridAction[] = [
      {
        label: translate("attribute_codebook.delete_value"),
        onClick: record => e => showDeleteValueWarningModal(record),
        type: "danger"
      }
    ];

    return (
      <Page {...this.props}>
        <CreateModalForm
          translate={translate}
          registerFormSubmitEventHandler={createAttributeCodebook}
          attributeModalVisible={attributeModalVisible}
          onChangeAttributeModalVisible={onChangeAttributeModalVisible}
        />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Select
            style={{ width: 300 }}
            placeholder={translate("attribute_codebook.choose_attribute_code")}
            onChange={onChangeAttributeCode}
            loading={this.state.loaders.attributeCodeListLoader}
            value={selectedAttributeCode}
            allowClear={true}
            showSearch={true}
            notFoundContent={translate("attribute_codebook.empty_text")}
            dropdownRender={menu => (
              <div>
                {menu}
                <Divider style={{ margin: "4px 0" }} />
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    padding: 5,
                    paddingTop: 0,
                    alignItems: "center"
                  }}
                  onMouseDown={e => e.preventDefault()}
                  onClick={() => onChangeAttributeModalVisible(true)}
                >
                  <Icon type="plus" style={{ marginRight: 5 }} />{" "}
                  {translate("attribute_codebook.add_codebook")}
                </div>
              </div>
            )}
          >
            {attributeCodeList.map(attributeCode => (
              <Option key={attributeCode.label} value={attributeCode.label}>
                {attributeCode.label}
              </Option>
            ))}
          </Select>
          {selectedAttributeCode && (
            <Button
              type={"danger"}
              icon={"delete"}
              style={{ marginLeft: 10, padding: 0, height: 31 }}
              onClick={showWarningModal}
            />
          )}
        </div>

        <Divider
          type={"horizontal"}
          style={{ marginTop: 12, marginBottom: 12 }}
        />
        {selectedAttributeCode && (
          <DataGrid
            title={`${translate(
              "attribute_codebook.title"
            )} ${selectedAttributeCode}`}
            columns={columns}
            translate={translate}
            dataSource={referenceList || []}
            allowCreate={true}
            allowUpdate={true}
            addButtonText={translate("attribute_codebook.add_button_text")}
            createForm={CreateForm}
            createModalTitle={`${translate(
              "attribute_codebook.create_modal_title"
            )} ${selectedAttributeCode}`}
            updateForm={UpdateForm}
            updateModalTitle={translate(
              "attribute_codebook.update_modal_title"
            )}
            loading={this.state.loaders.referenceListLoader}
            onUpdate={updateAttributeReference}
            onCreate={createAttributeReference}
            actions={actions}
          />
        )}
      </Page>
    );
  }
}
